// Библиотека элементов для сборки гибких знаков ПС (встреча 03.09.2026):
// сложные знаки из «Условные_тактические_знаки_набор_для_САКШЫ.docx» (воздушный
// коридор, заграждения, рубежи, колонны, курсы кораблей…) не растягиваются
// целиком — пользователь рисует линию и ставит на неё эти «кирпичики».
//
// Соглашения для SVG (viewBox 0 0 w h, по умолчанию 48×48):
//   • линия проходит горизонтально через anchor, направление движения — вправо (+x);
//     при прилипании к линии элемент поворачивается вдоль её касательной;
//   • anchor — точка, которая ставится на линию (по умолчанию центр);
//     у концевых элементов (стрелка, полукруг) — точка стыка с линией;
//   • цвет — currentColor (берётся из палитры), контур по умолчанию 3px.
//
// Ключ элемента в img_name: `lib.<key>` (см. encodeEl в ChpoMap.vue).

const S = 'fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"'
const F = 'fill="currentColor" stroke="none"'
const T = 'fill="currentColor" stroke="none" font-family="Arial, sans-serif" font-weight="700" text-anchor="middle"'

const g = (inner) => `<g ${S}>${inner}</g>`

// Стрелка вверх перпендикулярно линии с N поперечными чёрточками
// (рубеж развёртывания в ротные / батальонные / взводные колонны).
function perpArrow(bars) {
  const ys = [26, 21, 16].slice(0, bars)
  return g(`<path d="M24 34 V12"/>${ys.map(y => `<path d="M18 ${y} H30"/>`).join('')}<path d="M24 2 L18 14 H30 Z" ${F}/>`)
}

export const ELEMENT_GROUPS = [
  { key: 'ends',    label: 'Стрелки и концы линий' },
  { key: 'onLine',  label: 'На линии: заграждения, рубежи' },
  { key: 'forces',  label: 'Наряды, техника, корабли' },
  { key: 'symbols', label: 'Обстановка и символы' },
]

export const LINE_ELEMENTS = [
  // ───────────── Стрелки и концы линий ─────────────
  { key: 'arrow_filled', group: 'ends', label: 'Стрелка (залитая)', anchor: [44, 24],
    svg: `<path d="M44 24 L18 12 L24 24 L18 36 Z" ${F}/>` },
  { key: 'arrow_open', group: 'ends', label: 'Стрелка (открытая)', anchor: [44, 24],
    svg: g(`<path d="M26 12 L44 24 L26 36"/>`) },
  { key: 'arrow_hollow', group: 'ends', label: 'Стрелка (контур)', anchor: [44, 24],
    svg: g(`<path d="M44 24 L16 12 V36 Z"/>`) },
  { key: 'arrow_line', group: 'ends', label: 'Стрелка с древком',
    svg: g(`<path d="M4 24 H40"/>`) + `<path d="M46 24 L30 16 V32 Z" ${F}/>` },
  { key: 'arrow_both', group: 'ends', label: 'Двусторонняя стрелка',
    svg: g(`<path d="M12 24 H36"/>`) + `<path d="M2 24 L14 16 V32 Z M46 24 L34 16 V32 Z" ${F}/>` },
  { key: 'arrow_block_double', group: 'ends', label: 'Двойная стрелка (стык)', w: 64, h: 32,
    svg: `<path d="M2 16 L16 5 V27 Z M62 16 L48 5 V27 Z" ${F}/>` + `<g ${S} stroke-width="2.5"><path d="M16 12 H48 M16 20 H48"/></g>` },
  { key: 'arrow_big_hollow', group: 'ends', label: 'Большая стрелка (КПУГ)', w: 64, h: 40,
    svg: `<g ${S}><path d="M4 20 L22 4 V13 H60 V27 H22 V36 Z"/></g>` },
  { key: 'arrow_curved', group: 'ends', label: 'Изогнутая стрелка',
    svg: g(`<path d="M6 38 Q18 6 42 20"/><path d="M30 12 L42 20 L30 26"/>`) },
  { key: 'arrow_broken', group: 'ends', label: 'Ломаная стрелка (нарушение)',
    svg: g(`<path d="M4 14 L30 22 L18 30 L44 40"/>`) + `<path d="M46 41 L30 40 L38 30 Z" ${F}/>` },
  { key: 'cap_half', group: 'ends', label: 'Полукруг (стык)', anchor: [6, 32],
    svg: g(`<path d="M6 32 H10 A12 12 0 0 1 34 32"/>`) },
  { key: 'cap_knob', group: 'ends', label: 'Скругление (коридор)', anchor: [4, 32],
    svg: g(`<path d="M4 32 H24 A9 9 0 1 0 30 16"/>`) },
  { key: 'bar_end', group: 'ends', label: 'Черта-ограничитель',
    svg: g(`<path d="M24 10 V38"/>`) },
  { key: 'bar_double', group: 'ends', label: 'Двойная черта',
    svg: g(`<path d="M20 10 V38 M28 10 V38"/>`) },
  { key: 'tick_up', group: 'ends', label: 'Засечка вверх (спешивание)', anchor: [24, 34],
    svg: g(`<path d="M24 34 V14"/>`) },

  // ───────────── На линии: заграждения, рубежи ─────────────
  { key: 'gate', group: 'onLine', label: 'Ворота (в заграждении)',
    svg: `<path d="M6 12 L24 24 L6 36 Z M42 12 L24 24 L42 36 Z" ${F}/>` },
  { key: 'wicket', group: 'onLine', label: 'Калитка',
    svg: `<path d="M38 24 L12 12 V36 Z" ${F}/>` },
  { key: 'ticks3', group: 'onLine', label: 'Три засечки (сигн. заграждение)',
    svg: g(`<path d="M12 12 V36 M24 12 V36 M36 12 V36"/>`) },
  { key: 'capacitor', group: 'onLine', label: 'Разрыв ‖ (коридор, перевозка)',
    svg: g(`<path d="M20 8 V40 M28 8 V40"/>`) },
  { key: 'border_post', group: 'onLine', label: 'Знак госграницы (Ι)',
    svg: g(`<path d="M24 12 V36 M18 12 H30 M18 36 H30"/>`) },
  { key: 'dot', group: 'onLine', label: 'Точка',
    svg: `<circle cx="24" cy="24" r="6" ${F}/>` },
  { key: 'circle', group: 'onLine', label: 'Кружок',
    svg: g(`<circle cx="24" cy="24" r="9"/>`) },
  { key: 'circle_dot', group: 'onLine', label: 'Кружок с точкой',
    svg: g(`<circle cx="24" cy="24" r="10"/>`) + `<circle cx="24" cy="24" r="3.5" ${F}/>` },
  { key: 'cross', group: 'onLine', label: 'Крестик ×',
    svg: g(`<path d="M14 14 L34 34 M34 14 L14 34"/>`) },
  { key: 'plus', group: 'onLine', label: 'Плюс +',
    svg: g(`<path d="M24 12 V36 M12 24 H36"/>`) },
  { key: 'loops', group: 'onLine', label: 'Петли (малозаметное)',
    svg: g(`<circle cx="9" cy="24" r="6"/><circle cx="19" cy="24" r="6"/><circle cx="29" cy="24" r="6"/><circle cx="39" cy="24" r="6"/>`) },
  { key: 'wave', group: 'onLine', label: 'Волна (временная линия)',
    svg: g(`<path d="M2 24 Q7 12 12 24 T22 24 T32 24 T42 24 T46 22"/>`) },
  { key: 'zigzag', group: 'onLine', label: 'Зигзаг (поиск, связь)',
    svg: g(`<path d="M2 24 H12 L18 10 L26 38 L32 16 L36 24 H46"/>`) },
  { key: 'hatch3', group: 'onLine', label: 'Штрихи # (проволочное)',
    svg: g(`<path d="M12 36 L20 12 M20 36 L28 12 M28 36 L36 12"/>`) },
  { key: 'comb', group: 'onLine', label: 'Гребёнка (окоп, траншея)', anchor: [24, 18],
    svg: g(`<path d="M4 18 H44 M8 18 V32 M18 18 V32 M28 18 V32 M38 18 V32"/>`) },
  { key: 'lightning', group: 'onLine', label: 'Молния (электризуемое)', anchor: [18, 42],
    svg: g(`<path d="M32 2 L20 20 H30 L18 42"/><path d="M18 42 L17 32 M18 42 L26 36"/>`) },
  { key: 'arrow_perp', group: 'onLine', label: 'Стрелка вверх (атака)', anchor: [24, 34], svg: perpArrow(0) },
  { key: 'arrow_perp_1', group: 'onLine', label: 'Стрелка с 1 чертой (рота)', anchor: [24, 34], svg: perpArrow(1) },
  { key: 'arrow_perp_2', group: 'onLine', label: 'Стрелка с 2 чертами (батальон)', anchor: [24, 34], svg: perpArrow(2) },
  { key: 'arrow_perp_3', group: 'onLine', label: 'Стрелка с 3 чертами (взвод)', anchor: [24, 34], svg: perpArrow(3) },

  // ───────────── Наряды, техника, корабли ─────────────
  { key: 'bmp', group: 'forces', label: 'Боевая машина (огневой рубеж)',
    svg: g(`<path d="M15 40 V16 L24 6 L33 16 V40 Z M15 32 H33"/>`) },
  { key: 'fire_group', group: 'forces', label: 'Огневая группа (Y)', anchor: [24, 24],
    svg: g(`<path d="M24 4 V28 M14 16 H34 M24 28 L15 42 M24 28 L33 42"/>`) },
  { key: 'antitank', group: 'forces', label: 'Противотанковое орудие', anchor: [24, 24],
    svg: g(`<path d="M24 6 V30 M16 15 H32 M16 21 H32 M24 30 L17 42 M24 30 L31 42"/>`) },
  { key: 'search_group', group: 'forces', label: 'Поисковая группа (овал ↑)', anchor: [24, 34],
    svg: g(`<ellipse cx="24" cy="34" rx="7" ry="11"/><path d="M24 23 V10"/>`) + `<path d="M24 0 L19 11 H29 Z" ${F}/>` },
  { key: 'column_head', group: 'forces', label: 'Колонна (головная машина)', anchor: [44, 24],
    svg: g(`<path d="M44 24 L34 14 H8 V34 H34 Z M14 14 V34"/>`) },
  { key: 'column_service', group: 'forces', label: 'Взвод обслуживания', anchor: [24, 34],
    svg: g(`<path d="M8 34 H40 V16 H26 L20 24 H8 Z"/>`) },
  { key: 'column_rhomb', group: 'forces', label: 'Колонна (ромб)',
    svg: g(`<path d="M24 10 L42 24 L24 38 L6 24 Z"/>`) },
  { key: 'closing', group: 'forces', label: 'Техническое замыкание',
    svg: g(`<rect x="4" y="14" width="24" height="20"/><path d="M28 24 H34 M34 24 A5 5 0 1 1 42 20"/>`) },
  { key: 'transport_t', group: 'forces', label: 'Перевозка (круг Т)',
    svg: g(`<circle cx="24" cy="24" r="12"/><path d="M18 18 H30 M24 18 V32"/>`) },
  { key: 'transport_oval', group: 'forces', label: 'Перевозка (овал)',
    svg: g(`<ellipse cx="24" cy="24" rx="17" ry="9"/><path d="M24 15 V33"/>`) },
  { key: 'ship', group: 'forces', label: 'Пограничный корабль / катер', anchor: [44, 24],
    svg: g(`<path d="M44 24 L35 14 H4 V34 H35 Z"/>`) + `<g ${S} stroke="#16A34A"><path d="M8 17 L32 31 M8 31 L32 17"/></g>` },
  { key: 'boat_other', group: 'forces', label: 'Судно (с отсеками)', anchor: [4, 24],
    svg: g(`<path d="M4 24 L12 15 H32 V33 H12 Z M32 15 V33 M37 15 V33 M42 15 V33"/>`) },
  { key: 'vessel_oval', group: 'forces', label: 'Невоенное судно (овал)',
    svg: g(`<ellipse cx="24" cy="24" rx="18" ry="10"/>`) },
  { key: 'lens', group: 'forces', label: 'Буксируемое судно',
    svg: g(`<path d="M4 24 Q24 6 44 24 Q24 42 4 24 Z"/>`) },
  { key: 'zaslon', group: 'forces', label: 'Заслон (дуга)', anchor: [24, 34],
    svg: g(`<path d="M6 36 A20 16 0 0 1 42 36 M24 20 V8"/>`) },

  // ───────────── Обстановка и символы ─────────────
  { key: 'flag', group: 'symbols', label: 'Флажок', anchor: [10, 44],
    svg: g(`<path d="M10 44 V4"/><path d="M10 4 H42 L34 14 H10 Z" fill="currentColor" fill-opacity="0.25"/>`) },
  { key: 'parachute', group: 'symbols', label: 'Парашют (выброска)',
    svg: g(`<path d="M6 20 A18 13 0 0 1 42 20 Z"/><path d="M6 20 L24 44 L42 20"/>`) },
  { key: 'landing', group: 'symbols', label: 'Высадка десанта',
    svg: g(`<path d="M24 44 V14 M12 6 Q24 22 36 6"/>`) },
  { key: 'heli_mark', group: 'symbols', label: 'Вертолёт / высадка группы', anchor: [24, 44],
    svg: g(`<path d="M24 44 V22 M14 6 L34 26 M34 6 L14 26"/>`) },
  { key: 'triangle', group: 'symbols', label: 'Треугольник (наблюдение)',
    svg: g(`<path d="M8 36 L24 10 L40 36 Z"/>`) },
  { key: 'uav_angle', group: 'symbols', label: 'Позиция БПЛА (угол)',
    svg: g(`<path d="M44 36 H6 L38 12 M22 36 L26 26"/>`) },
  { key: 'triangle_r', group: 'symbols', label: 'Пункт встречи (Р)',
    svg: g(`<path d="M6 42 L24 8 L42 42 Z"/>`) + `<text x="24" y="37" font-size="16" ${T}>Р</text>` },
  { key: 'circle_u', group: 'symbols', label: 'Должностное лицо (У)',
    svg: g(`<circle cx="24" cy="24" r="16"/>`) + `<text x="24" y="31" font-size="18" ${T}>У</text>` },
  { key: 'circle_cu', group: 'symbols', label: 'Целеуказание (ЦУ)',
    svg: g(`<circle cx="24" cy="24" r="18"/>`) + `<text x="24" y="30" font-size="15" ${T}>ЦУ</text>` },
  { key: 'water_point', group: 'symbols', label: 'Пункт водоснабжения',
    svg: g(`<circle cx="24" cy="24" r="16"/>`) + `<circle cx="24" cy="24" r="7" ${F}/>` },
  { key: 'camera', group: 'symbols', label: 'Видеокамера',
    svg: g(`<path d="M4 14 H30 V34 H4 Z M30 24 L44 10 M30 24 L44 38"/>`) },
  { key: 'obs_v', group: 'symbols', label: 'Наблюдение (V-опора)', anchor: [24, 38],
    svg: g(`<path d="M14 6 L24 20 L34 6 M20 20 V38 H28 V20"/>`) },
  { key: 'obs_u', group: 'symbols', label: 'Тепловидение (U-опора)', anchor: [24, 38],
    svg: g(`<path d="M14 6 Q14 20 24 20 Q34 20 34 6 M20 20 V38 H28 V20"/>`) },
  { key: 'crown', group: 'symbols', label: 'Корона (криминогенная обст.)',
    svg: g(`<path d="M8 38 L10 14 L18 26 L24 10 L30 26 L38 14 L40 38 Z"/>`) },
  { key: 'fire', group: 'symbols', label: 'Пожар',
    svg: g(`<path d="M14 42 C4 32 12 22 16 10 C20 20 22 22 24 4 C30 16 36 20 34 10 C44 22 44 34 34 42 Z"/>`) },
  { key: 'hooks', group: 'symbols', label: 'Орудия лова (крючки)',
    svg: g(`<path d="M18 6 V28 A7 7 0 1 1 8 30 M34 6 V28 A7 7 0 1 1 24 30"/>`) },
  { key: 'people_v', group: 'symbols', label: 'Обстрел (кружок и лучи)', anchor: [10, 24],
    svg: g(`<circle cx="10" cy="24" r="6"/><path d="M16 24 L44 12 M16 24 L44 36"/>`) },
  { key: 'star_burst', group: 'symbols', label: 'Место столкновения',
    svg: g(`<path d="M24 4 V44 M4 24 H44 M10 10 L38 38 M38 10 L10 38"/>`) },
]

const BY_KEY = Object.fromEntries(LINE_ELEMENTS.map(e => [e.key, e]))

export function getLineElement(key) {
  return BY_KEY[String(key || '').replace(/^lib\./, '')] || null
}

// Полный SVG элемента (для превью в сайдбаре и отрисовки на карте).
// stretch — растянуть по ширине/высоте контейнера без сохранения пропорций.
export function lineElementSvg(el, { color = '#000000', width, height, stretch = false } = {}) {
  const w = el.w || 48
  const h = el.h || 48
  const size = width ? `width="${width}" height="${height || width}"` : 'width="100%" height="100%"'
  const ratio = stretch ? ' preserveAspectRatio="none"' : ''
  return `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 ${w} ${h}"${ratio} ${size} style="color:${color};overflow:visible;display:block">${el.svg}</svg>`
}
